import React from 'react';
import PropTypes from 'prop-types';
import CTASection from '../CTASection';

const direction = 'column';

function CTAColumnSection(props) {
  return <CTASection direction={direction} {...props} />;
}

CTAColumnSection.propTypes = {
  section: PropTypes.object.isRequired,
};

export default CTAColumnSection;



// WEBPACK FOOTER //
// ./src/site-render/src/CTAColumnSection/CTAColumnSection.js